import { getCleanUrl } from 'js/utils/url.util';
import { equals, identity, ifElse, pipe, when } from 'ramda';
import { languageService } from 'js/services/language.service';

const getPathLang = langToSet => pipe(
    languageService.getAliasForLanguage,
    when(
        identity,
        ifElse(
            equals(langToSet),
            languageService.getShortLanguage,
            identity
        )
    )
)(langToSet);

export const setCurrentLanguage = ({ langToSet, currentLang, history, location, defaultLang, url }) => {
    if (langToSet === currentLang) {
        return;
    }

    const pathLang = getPathLang(langToSet);
    const pathname = url ? url[langToSet] || url[defaultLang] : location.pathname;

    if (pathLang) {
        history.replace({
            ...location,
            state: { ...location.state },
            pathname: `/${pathLang}${getCleanUrl(pathname)}`
        });
    }
};

export const deletePathLanguage = ({ location, history }) => {
    history.replace({
        ...location,
        pathname: getCleanUrl(location.pathname)
    });
};
